import $ from "jquery";
import "jquery-validation/dist/jquery.validate";

import loadingButton from "../components/loadingButton";
import i18n from "@I18n/services/i18n";
import messages from "./messages";

$(document).ready(function () {
  // Forms - Sign up
  $("#new_user").validate({
    ignore: ".ignore",
    rules: {
      "user[surname]": {
        required: true,
        detectAtInInput: true,
      },
      "user[name]": {
        required: true,
        detectAtInInput: true,
      },
      "user[email]": {
        required: true,
        customEmail: true,
      },
      "user[password]": {
        required: true,
        minlength: {
          param: 6,
        },
      },
    },
    messages: {
      "user[surname]": {
        required: i18n.formatMessage(messages.firstname),
        detectAtInInput: i18n.formatMessage(messages.firstnameErrorAt),
      },
      "user[name]": {
        required: i18n.formatMessage(messages.name),
        detectAtInInput: i18n.formatMessage(messages.nameErrorAt),
      },
      "user[email]": {
        required: i18n.formatMessage(messages.email),
        customEmail: i18n.formatMessage(messages.email),
      },
      "user[password]": {
        required: i18n.formatMessage(messages.password),
        minlength: i18n.formatMessage(messages.passwordMinLength),
      },
    },
    submitHandler: function (form) {
      loadingButton(form);
      form.submit();
    },
  });
});
